import { Spinner, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function LoadingSection() {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center">
      <Text>{t("common.loading")}</Text>
      <Spinner color="primary.DEFAULT" />
    </Stack>
  );
}
